import type { Customer } from '@eliadmin/core/src/api/customers/customers-types';

export function isCurriculumCompleted(customer: Customer | null | undefined) {
  return customer?.metadata !== null && customer?.metadata !== undefined;
}
